import React from "react";

//components

import PopUpHeading from "../../components/PopUps/PopUpHeading";
import PopUpBody from "../../components/PopUps/PopUpBody";
import PopUpButtons from "../../components/PopUps/PopUpButtons";

//styles
import { PopUpBox } from "../../components/PopUps/PopUp.elements";
import PopUpStandby from "../../components/PopUps/PopUpStandby";

const PopUps = ({ popuppage }) => {
  return (
    <>
      {popuppage.name1 === "standby" ? (
        <PopUpStandby />
      ) : (
        <>
          <PopUpBox>
            <PopUpHeading popuppage={popuppage} />
            <PopUpBody popuppage={popuppage} />
            <PopUpButtons popuppage={popuppage}></PopUpButtons>
          </PopUpBox>
        </>
      )}
    </>
  );
};

export default PopUps;
